import { render, staticRenderFns } from "./ProviderRating.vue?vue&type=template&id=59ed92b1&scoped=true&"
import script from "./ProviderRating.vue?vue&type=script&lang=js&"
export * from "./ProviderRating.vue?vue&type=script&lang=js&"
import style0 from "./ProviderRating.vue?vue&type=style&index=0&id=59ed92b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed92b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFadeTransition,VFlex,VLayout})
